import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70ac2b94")

_pushScopeId("data-v-70ac2b94")
const _hoisted_1 = { class: "container popup-container" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "rate-title" }
const _hoisted_4 = { class: "rate-content" }
const _hoisted_5 = { class: "rate-date" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "rate-item-title" }, "Date", -1)
const _hoisted_7 = { class: "rate-date-calendar" }
const _hoisted_8 = { class: "rate-currency" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "rate-item-title" }, "Currency", -1)
const _hoisted_10 = { class: "rate-currency-select" }
const _hoisted_11 = { class: "rate-rate" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "rate-item-title" }, "Rate", -1)
const _hoisted_13 = { class: "currency-footer" }
const _hoisted_14 = { class: "currency-footer-row1 save-rate" }
const _hoisted_15 = {
  key: 0,
  class: "currency-footer-row"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "space-between-btns" }, null, -1)
const _hoisted_17 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.id > 0 ? 'Edit Rate' : 'Create Rate'), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_Calendar, {
              ref: "calendar",
              modelValue: _ctx.startDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.startDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              onDateSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateChanged()))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_Multiselect, {
              valueProp: "id",
              label: "symbol",
              options: _ctx.currenciesWithoutLocal,
              modelValue: _ctx.rate.currencyId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.rate.currencyId = $event))
            }, null, 8, ["options", "modelValue"])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode("div", null, [
            _withDirectives(_createVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.rate.rate = $event))
            }, null, 512), [
              [_vModelText, _ctx.rate.rate]
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveRate()))
          }, _toDisplayString(_ctx.$t('button.save')), 1)
        ]),
        (_ctx.id > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("button", {
                class: "cancel-rate",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancel()))
              }, _toDisplayString(_ctx.$t('button.cancel')), 1),
              _hoisted_16
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode("button", {
                class: "cancel-rate-solo-btn",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancel()))
              }, _toDisplayString(_ctx.$t('button.cancel')), 1)
            ]))
      ])
    ])
  ]))
})